import{excludeForwardProps as o}from"../../../common/utils/excludeForwardProps.js";import{Box as r,styled as e}from"@mui/joy";var s={sm:10,md:18,lg:26},l=(o="lg")=>.8*s[o],i=e(r,{shouldForwardProp:o(["color","size"])})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({size:o="lg"})=>s[o]}px;
  height: ${({size:o="lg"})=>s[o]}px;
  border-radius: 50%;
  background-color: ${({color:o})=>o};
`;export{i as ColorTagStyled,l as getCheckIconSize};
//# sourceMappingURL=ColorTagStyled.js.map